import { Pareto, Bars, Scatter, Bell } from "./Charts";
import { Decomp, Accuracy, Sawtooth, Stack } from "./Charts2";
import { Flow, OriginLabels, PolicyMatrix, ClassShift, Masking } from "./Blocks";
import { RoleMatrix } from "./RoleMatrix";
import { Phases, Raci, Layers, Swimlane, Cadence } from "./Method";

export const DIAGRAMS = {
  pareto: Pareto, bars: Bars, scatter: Scatter, bell: Bell,
  decomp: Decomp, accuracy: Accuracy, sawtooth: Sawtooth, stack: Stack,
  flow: Flow, origin: OriginLabels, matrix: PolicyMatrix, shift: ClassShift, masking: Masking, roles: RoleMatrix,
  phases: Phases, raci: Raci, layers: Layers, swimlane: Swimlane, cadence: Cadence,
};
